import {
  Modal,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
} from "@mui/material";
import { RuleItem } from "@types";
import { useState } from "react";
import { toast } from "react-toastify";
import { addInspRule } from "../../services/inspRuleService";
import { t } from "i18next";

interface RuleCreateModalProps {
  modelList: { uuid: string; name: string }[];
  open: boolean;
  onClose: () => void;
  onCreated: (newRule: RuleItem) => void;
}

export const RuleCreateModal = ({
  modelList,
  open,
  onClose,
  onCreated,
}: RuleCreateModalProps) => {
  const [form, setForm] = useState({
    name: "",
    description: "",
    recipe_regex: "",
    image_regex: "",
    model_uuid: "",
  });

  const handleClose = () => {
    setForm({
      name: "",
      description: "",
      recipe_regex: "",
      image_regex: "",
      model_uuid: "",
    });
    onClose();
  };

  const handleSave = async () => {
    try {
      const response = await addInspRule(form); // 기존 API 함수로 교체
      onCreated(response); // 생성된 rule을 부모로 전달
      handleClose();
    } catch (error) {
      toast.error(t("CreateInspRuleFailMsg"));
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          width: 500,
          bgcolor: "var(--dk-surface, white)",
          borderRadius: 3,
          mx: "auto",
          mt: "13%",
          p: 3,
        }}
      >
        <Typography variant="h6" mb={2}>
          {t("CreateInspRule")}
        </Typography>

        {(
          [
            { key: "name", label: t("InspRuleName") },
            { key: "description", label: t("Description") },
            { key: "recipe_regex", label: t("MaterialName") },
            { key: "image_regex", label: t("FileName") },
          ] as const
        ).map(({ key, label }) => (
          <TextField
            key={key}
            label={label}
            fullWidth
            sx={{ mb: 2 }}
            value={form[key]}
            onChange={(e) => setForm({ ...form, [key]: e.target.value })}
          />
        ))}

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>{t("Model")}</InputLabel>
          <Select
            value={form.model_uuid}
            label={t("Model")}
            onChange={(e) => setForm({ ...form, model_uuid: e.target.value })}
          >
            {modelList.map((model) => (
              <MenuItem key={model.uuid} value={model.uuid}>
                {model.name} ({model.uuid.slice(0, 6)})
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <Button onClick={handleClose}>{t("Cancel")}</Button>
          <Button variant="contained" onClick={handleSave}>
            {t("Save")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
